import React from 'react';
import { useAuth } from '../context/AuthContext';
import './RejectedScreen.css';

/**
 * RejectedScreen Component
 * 
 * Shown to users whose registration request was rejected by admin
 */
const RejectedScreen = () => {
  const { user, logout } = useAuth();

  return (
    <div className="rejected-screen">
      <div className="rejected-card">
        <div className="rejected-icon">❌</div>
        <h1>Toegang geweigerd</h1>
        <p>
          Helaas is je aanvraag voor account <strong>{user?.email}</strong> afgewezen.
        </p>
        <p className="rejected-hint">
          Neem contact op met de beheerder als je denkt dat dit een fout is.
        </p>
        <button className="logout-button" onClick={logout}>
          Uitloggen
        </button>
      </div>
    </div>
  );
};

export default RejectedScreen;
